import { createContext, useContext } from 'react';

export const PopperMenuContext = createContext();

export const usePopperMenu = () => useContext(PopperMenuContext);
